import React from 'react'
import { connect } from 'react-redux'
import Alerts from '../../components/ui/Alerts'
import { clearMessage } from '../../actions/uiActions'
import { bindActionCreators } from 'redux'

class AlertsContainer extends React.Component {
    state = {
        timeout: null
    }

    popupWithTimer = (time) => {
        if (this.state.timeout === null) {
            let timeout = setTimeout(this.hide, time)
            this.setState({ timeout })
        }
    }

    hide = () => {
        this.props.clearMessage()
        clearTimeout(this.state.timeout)
        this.setState({ timeout: null })
    }

    render() {
        if (this.props.message && this.props.message.length > 0) {
            this.popupWithTimer(8000)
            return <Alerts message={this.props.message} messageType={this.props.messageType} />
        } else {
            return null
        }
    }
}

function mapStateToProps(state) {
    return {
        message: state.ui.message,
        messageType: state.ui.messageType,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ clearMessage }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertsContainer)